<template>
  <div>
    <div class="headerTop">
      <div class="tt-container">
        <div class="head">
          欢迎您，{{ name }}
          <a href="/login" class="logout">安全退出</a>
          <span class="line">|</span>
          服务热线：0755-83015888 服务时间：08:00 - 24:00
        </div>
      </div>
    </div>
    <div class="border">
      <div class="tt-container">
        <div class="header-nav-wrap">
          <div class="logo">
            <router-link
              tag="div"
              :to="`/${
                beforeMiddle == '1'
                  ? privatePermission == 1
                    ? 'beforeIndex'
                    : 'myApplyOrder'
                  : 'index'
              }`"
              style="
                height: 70px;
                width: 156px;
                cursor: pointer;
                display: flex;
                align-items: center;
              "
            >
              <img
                v-if="
                  accountInfo.enterpriseSetting &&
                  accountInfo.enterpriseSetting.logoweb
                "
                :src="accountInfo.enterpriseSetting.logoweb"
                alt
                height="100%"
              />
              <img
                v-else
                :src="require('@img/tt-logo.png')"
                :alt="systemName"
                width="156px"
                height="36px"
              />
            </router-link>
          </div>
          <div class="nav-items">
            <template v-if="beforeMiddle == '1'">
              <div
                v-if="privatePermission == 1"
                class="nav-item"
                :class="activeClass == 'beforeIndex' ? 'on' : ''"
                @click="gotoPage('/beforeIndex')"
              >
                因私预订
              </div>
              <div
                class="nav-item"
                :class="activeClass == 'myApplyOrder' ? 'on' : ''"
                @click="gotoPage('/myApplyOrder')"
              >
                我的出差申请
              </div>
            </template>
            <div
              class="nav-item"
              :class="activeClass == 'index' ? 'on' : ''"
              @click="gotoPage('/index')"
              v-else
            >
              首页
            </div>

            <div
              v-has="'xc'"
              class="nav-item"
              :class="activeClass == 'trip' ? 'on' : ''"
              @click="
                gotoPage(
                  approvelflag
                    ? beforeMiddle == '1'
                      ? '/beforeApprove'
                      : '/trip'
                    : '/trip/domesticair'
                )
              "
            >
              <el-badge :value="mangagetotal ? mangagetotal : ''" :max="99">
                行程
              </el-badge>
            </div>
            <div
              v-if="accountInfo.isreport == '1'"
              v-has="'slbb'"
              class="nav-item"
              :class="activeClass == 'report' ? 'on' : ''"
              @click="gotoPage('/reportManage')"
            >
              报表
            </div>
            <div
              v-has="'gl'"
              class="nav-item"
              :class="activeClass == 'manage' ? 'on' : ''"
              @click="gotoPage('/userinfo')"
            >
              管理
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-alert type="warning" class="tit-head" :closable="false" v-if="notify">
      <template slot="title">
        <i class="iconfont icontongzhi"></i>
        最新通知
      </template>
      <marquee
        behavior="scroll"
        scrollamount="3"
        direction="left"
        onmouseover="this.stop();"
        onmouseout="this.start();"
        class="tt-orange scrollamoutbox"
      >
        {{ notify }}
      </marquee>
    </el-alert>
  </div>
</template>

<script>
import * as userApi from '@api/userApi'
import * as indexApi from '@api/indexApi'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'pageHeader',
  data () {
    return {
      name: '',
      accountInfo: {},
      accountPrice: 0,
      mangagetotal: 0,
      timer: null,
      notify: '',
      beforeMiddle: '',
      privatePermission: ''
    }
  },
  computed: {
    ...mapState(['user', 'indexStore']),
    activeIndex () {
      return '/' + this.$route.path.split('/')[1]
    },
    activeClass () {
      let str = 'index'
      if (this.$route.path.indexOf('/beforeIndex') !== -1) {
        str = 'beforeIndex'
      }
      if (this.$route.path.indexOf('/myApplyOrder') !== -1) {
        str = 'myApplyOrder'
      }
      if (
        this.$route.path.indexOf('/trip') !== -1 ||
        this.$route.path.indexOf('/beforeApprove') !== -1
      ) {
        str = 'trip'
      }
      if (this.$route.path.indexOf('/userinfo') !== -1) {
        str = 'manage'
      }
      if (this.$route.path.indexOf('/reportManage') !== -1) {
        str = 'report'
      }
      return str
    },
    balance () {
      if ((this.user || {}).accontPrice) {
        let list = (this.user.accontPrice || []).filter(
          (item) => item.type === 2000002
        )
        if (list.length) {
          return this.user.accontPrice.filter(
            (item) => item.type === 2000002
          )[0].balance
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    accontPriceflag () {
      return this.indexStore.accountInfo.isquota === '1'
    },
    approvelflag () {
      return this.indexStore.accountInfo.rolePermission.indexOf('xxsp') !== -1
    },
    manageflag () {
      return (
        this.indexStore.accountInfo.rolePermission.indexOf('xxsp') !== -1 ||
        this.indexStore.accountInfo.rolePermission.indexOf('xxgl') !== -1
      )
    }
  },
  created () {
    this.loadData()
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    ...mapActions(['getCustomerInfo']),
    async loadData () {
      await this.getCustomerInfo()
      await this.getnotify()
      this.accountInfo = this.indexStore.accountInfo
      this.beforeMiddle = this.accountInfo.enterprise.beforeMiddle
      this.privatePermission = this.accountInfo.enterprise.privatePermission
      this.name = this.indexStore.customerInfo.name
      await this.selapprovel()
    },
    async selapprovel () {
      let a =
        this.beforeMiddle === '1'
          ? 'beforeApprovePage'
          : 'findApproveOrderList'
      const { data } = await userApi[a]({ opStatus: 1 })
      if (data) {
        this.mangagetotal =
          (this.beforeMiddle === '1'
            ? data.data.records.length
            : data.data.length) || 0
      }
    },
    async getSurplus (customerNo) {
      indexApi
        .accountSelect({ customerNo })
        .then((res) => {
          if (res.data.code === '200') {
            this.$store.commit('getAccontPrice', res.data.data)
          }
        })
        .catch(() => {})
    },
    async getnotify () {
      const { data } = await indexApi.getNotifylist()
      if (data.code === '1' && (data.data || []).length) {
        const { data: res } = await indexApi.queryNotifyContent(data.data[0])
        this.notify = `【${data.data[0].title}】 ${res.data}`
      }
    },
    // 页面跳转
    gotoPage (uri) {
      this.$router.push(uri)
    }
  }
}
</script>
<style lang="less" scoped>
.scrollamoutbox {
  width: calc(100vw - 130px);
}
.headerTop {
  background: #f2f2f2;
  .head {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #0084ff;
    .line {
      padding: 0 10px;
    }
  }
  .logout {
    margin-left: 20px;
    color: red;
    &:hover {
      text-decoration: underline;
    }
  }
}
.border {
  padding-top: 20px;
  border-bottom: 2px solid #006eff;
}
.header-nav-wrap {
  display: flex;
  align-items: center;
  .logo {
    width: 400px;
  }
  .nav-items {
    display: flex;
    align-items: center;
    .nav-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 70px;
      min-width: 70px;
      margin: 0 20px;
      font-size: 16px;
      cursor: pointer;
      padding: 0 15px;
      border-radius: 5px 5px 0 0;
      font-size: 20px;
      &:hover {
        color: #006eff;
      }
      &.on {
        background-color: #006eff;
        color: #fff;
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="less">
.tit-head {
  height: 24px;
  .el-alert__icon.is-big {
    font-size: 16px !important;
  }
  .el-alert__closebtn {
    top: 7px !important;
  }
  .el-alert__content {
    display: flex !important;
    align-items: center !important;
  }
  .el-alert__title.is-bold {
    width: 80px !important;
    color: #ff7600 !important;
  }
}
// .el-badge__content.is-fixed {
//   top: 13px !important;
//   right: 66px !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue